import React from 'react';
import { Card } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import ClubCard from './ClubCard';

const ClubList = ({ clubs, row, history }) => {
  function handleClick(url) {
    history.push(url);
  }
  return (
    <Card.Group itemsPerRow={row} doubling={true}>
      {clubs.map(club => ClubCard(club, handleClick))}
    </Card.Group>
  );
};

ClubList.propTypes = {
  clubs: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired
    })
  ).isRequired
};

export default ClubList;



// WEBPACK FOOTER //
// ./src/components/ClubList/ClubList.js